import { FC } from 'react';

import { CountryViewModel } from '@api/models/CountryViewModel';
import Dropdown from '@components/Dropdown';
import { TURKEY_ID } from '@constants/constants';
import { useCountries } from '@hooks/hooks';
import { DropdownSelectProps } from '@components/Dropdown/DropdownInterface';

export type IDropdownsPassaportCountry = DropdownSelectProps<CountryViewModel>;

const PassaportCountry: FC<IDropdownsPassaportCountry> = ({
  onChange = () => null,
  ...rest
}) => {
  const countries = useCountries();

  return (
    <Dropdown
      items={countries as CountryViewModel[]}
      renderLabel={(p) => (!p ? 'Pasaportu Veren Ülke' : p.name)}
      renderOption={(p) => p.name}
      optionsZIndex={4}
      onChange={(country) =>
        onChange(
          Number(country.code ?? TURKEY_ID) as unknown as CountryViewModel
        )
      }
      {...rest}
    />
  );
};

export default PassaportCountry;
